import { render } from "./CapacityPickupBox.vue?vue&type=template&id=3f01aec3&scoped=true&ts=true"
import script from "./CapacityPickupBox.vue?vue&type=script&lang=ts"
export * from "./CapacityPickupBox.vue?vue&type=script&lang=ts"

import "./CapacityPickupBox.vue?vue&type=style&index=0&id=3f01aec3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f01aec3"]])

export default __exports__